/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

/**
 * Service for Survey API
 *
 */
export default class SurveyService {

    surveyApi;
    _httpService;

    constructor(httpService) {
        // Create Survey API URL based off current env
        this.surveyApi = `${process.env.REACT_APP_SURVEY_API_BASE_URL}/survey`
        this._httpService = httpService;
    }

    /**
     * Gets the survey definition for the given survey id
     *
     * @param surveyId id of survey definition
     * @return survey definition in json
     */
    async getSurveyDefinitionFromAPI(surveyId) {
        const response = await this._httpService.fetch(`${this.surveyApi}/${surveyId}/definition`);
        return await response.json();
    }
}